@if ({ loanInfo: loanInfo$ | async }; as vm) {
  <div class="row mb-3">
    <div class="col">
      <p-panel class="secondary-panel">
        <ng-template pTemplate="header">Mortgage Information</ng-template>
        @if (vm.loanInfo) {
          <cmg-info-panel-content>
            <div class="row">
              <div class="col-12 col-md-6 border-md-end">
                <cmg-info-row
                  label="Loan Type"
                  [value]="vm.loanInfo?.mortgageAppliedFor | toNameOrValueNoSelect: mortgageAppliedForOptions : 'name'"
                />
              </div>
              <div class="col-12 col-md-6 ps-md-4">
                <cmg-info-row label="Type" [value]="vm.loanInfo?.amortizationTypeDescription | emptyToDash" />
              </div>
              <div class="col-12 col-md-6 border-md-end">
                <cmg-info-row label="Purpose of Loan" [value]="vm.loanInfo?.loanPurpose | toNameOrValueNoSelect: purposeOfLoanOptions : 'name'" />
              </div>
              <div class="col-12 col-md-6 ps-md-4">
                <cmg-info-row
                  label="Amortization Type"
                  [value]="vm.loanInfo?.amortizationType | toNameOrValueNoSelect: amortizationTypeOptions : 'name'"
                />
              </div>
              <div class="col-12 col-md-6 border-md-end">
                <cmg-info-row label="Balloon" [value]="vm.loanInfo?.isBalloon | yesNo" />
              </div>
            </div>
          </cmg-info-panel-content>
        }
      </p-panel>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col">
      <p-panel class="secondary-panel">
        <ng-template pTemplate="header">Lien Position</ng-template>
        <cmg-info-panel-content>
          <div class="row">
            <div class="col-12 col-md-6 border-md-end">
              <cmg-info-row label="First Mortgage" [value]="loan1008Data?.firstMortgage | yesNo" />
            </div>
            <div class="col-12 col-md-6 ps-md-4">
              <cmg-info-row
                label="Owner of First Mortgage"
                [value]="loan1008Data?.ownerOfFirstMortgage ? getMatchString(loan1008Data?.ownerOfFirstMortgage) : '-'"
              />
            </div>
            <div class="col-12 col-md-6 border-md-end">
              <cmg-info-row label="Original Amount of First Mortgage" [value]="loan1008Data?.amountOfFirstMortgage | currency | emptyToDash" />
            </div>
            <div class="col-12 col-md-6 ps-md-4">
              <cmg-info-row label="Second Mortgage" [value]="loan1008Data?.secondMortgage | yesNo" />
            </div>
          </div>
        </cmg-info-panel-content>

        <div>
          <div class="lead fw-bold fs-5 py-3">Subordinate Financing</div>
          @if (vm.loanInfo) {
            <cmg-info-panel-content>
              <div class="row">
                <div class="col-12 col-md-6 border-md-end">
                  <cmg-info-row
                    label="Sub Fi Type"
                    [value]="vm.loanInfo?.subOrdinateFinance?.subFiType | toNameOrValueNoSelect: subFiTypes : 'name'"
                  />
                </div>
                <div class="col-12 col-md-6 ps-md-4">
                  <cmg-info-row label="Term in Months" [value]="loan1008Data?.subFiTerm | emptyToDash" />
                </div>
                <div class="col-12 col-md-6 border-md-end">
                  <cmg-info-row label="HELOC Credit Limit" [value]="loan1008Data?.helocMaxBalance | currency | emptyToDash" />
                </div>
                <div class="col-12 col-md-6 ps-md-4">
                  <cmg-info-row label="Loan Amount" [value]="vm.loanInfo?.subOrdinateFinance?.subFiBaseLoan | currency | emptyToDash" />
                </div>
                <div class="col-12 col-md-6 border-md-end">
                  <cmg-info-row label="Calculated P&I" [value]="vm.loanInfo?.subOrdinateFinance?.calculatedPi | currency | emptyToDash" />
                </div>
                <div class="col-12 col-md-6 ps-md-4">
                  <cmg-info-row label="Calculated as interest only" [value]="vm.loanInfo?.subOrdinateFinance?.subFiIntOnly | yesNo" />
                </div>
                <div class="col-12 col-md-6 border-md-end">
                  <cmg-info-row label="HCLTV" [value]="vm.loanInfo?.subOrdinateFinance?.hcltv | emptyToDash" />
                </div>
                <div class="col-12 col-md-6 ps-md-4">
                  <cmg-info-row label="Interest Rate" [value]="loan1008Data?.subFiIntRate / 100 | percent: '1.3-3' | emptyToDash" />
                </div>
                <div class="col-12 col-md-6 border-md-end">
                  <cmg-info-row
                    label="Exclude the subordinate loan amount from the 'cash from/to borrower' calculation on the details of transaction"
                    [value]="vm.loanInfo?.subOrdinateFinance?.excludeSubFi | yesNo"
                  />
                </div>
              </div>
            </cmg-info-panel-content>
          }
        </div>
      </p-panel>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <p-panel class="secondary-panel">
        <ng-template pTemplate="header">Additional Property Information</ng-template>
        @if (vm.loanInfo) {
          <cmg-info-panel-content>
            <div class="row">
              <div class="col-12 col-md-6 border-md-end">
                <cmg-info-row label="Original Loan Amount" [value]="vm.loanInfo?.totalLoanAmount | currency | emptyToDash" />
              </div>
              <div class="col-12 col-md-6 ps-md-4">
                <cmg-info-row
                  label="Initial P&I Payment"
                  [value]="vm.loanInfo?.loanInfoCombinedHousingExpense?.firstMortgageProposed | currency | emptyToDash"
                />
              </div>
              <div class="col-12 col-md-6 border-md-end">
                <cmg-info-row label="Initial Note Rate" [value]="vm.loanInfo?.interestRate / 100 | percent: '1.3-3' | emptyToDash" />
              </div>
              <div class="col-12 col-md-6 ps-md-4">
                <cmg-info-row label="Loan Term (in Months)" [value]="vm.loanInfo?.loanTerm | emptyToDash" />
              </div>
              <div class="col-12 col-md-6 border-md-end">
                <cmg-info-row
                  label="Mortgage Originator"
                  [value]="loan1008Data?.transmittal.originatorType ? getMatchString(loan1008Data?.transmittal.originatorType) : '-'"
                />
              </div>
              <div class="col-12 col-md-6 ps-md-4">
                <cmg-info-row label="Buydown" [value]="vm.loanInfo?.buyDowns | toNameOrValueNoSelect: buyDownType" />
              </div>
              <div class="col-12 col-md-6 border-md-end">
                <cmg-info-row label="Broker/Correspondent Name and Company Name" [value]="loan1008Data?.transmittal.brokerName | emptyToDash" />
              </div>
            </div>
          </cmg-info-panel-content>
        }
      </p-panel>
    </div>
  </div>
}
